<template>

    <tr :class="{'v-reports__group': header}">

        <td class="v-reports__cell">
            <div class="v-reports__order-id">
                <v-link :to="'orders/' + row.id">
                    {{ row.reference }}
                </v-link>
            </div>
        </td>
        <td class="v-reports__cell">
            <div class="v-reports__date">
                {{ row.date.date | formatDateFullCompact }}
            </div>
        </td>
        <td class="v-reports__cell">
            <div class="v-reports__salesperson">
                {{ row.salesPerson }}
            </div>
        </td>
        <td class="v-reports__cell">
            <div class="v-reports__customer">
                {{ row.customer.email }}
            </div>
        </td>
        <td class="v-reports__cell">
            <template v-for="orderLine in row.orderLines">
                <div class="v-reports__product">
                    <div class="v-reports__product-id">
                        {{ orderLine.axNumber }}
                    </div>
                    <div class="v-reports__product-name">
                        {{ orderLine.model }}
                    </div>
                </div>
            </template>
        </td>
        <td class="v-reports__cell">
            <div class="v-reports__car">
                {{ row.carModel }}
            </div>
        </td>
        <td class="v-reports__cell">
            <div class="v-reports__administration-status">
                <v-status :status="row.status"/>
            </div>
        </td>

        <td class="v-reports__cell">
            <div class="v-reports__installation-status">
                <v-status :status="row.installationStatus"/>
            </div>
        </td>
        <td class="v-reports__cell v-reports__cell--number">
            <div class="v-reports__line-total">
                {{ row.total | toCurrency }}
            </div>
        </td>
    </tr>

</template>

<script>
  import vLink from "./vLink"
  import vStatus from "./vStatus"

  export default {
    name: "vReportsRow",
    components: {
      vLink,
      vStatus,
    },
    props: {
      header: { type: Boolean, default: false },
      row: { type: Object, default: null }
    },
  }
</script>

<style scoped>

</style>